export default __webpack_public_path__ + "static/highlight-1-8b2ca99bf845a6a14d9c1dfa918c207b.svg";